import { FINANCE_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  getRequests ({
    limit = 999,
    page = 1,
    status,
    sort,
    search,
    tags = [],
    requestType = 1,
    projectManager,
    businessConsultant
  }) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`, `requestType[]=${requestType}`]
    if (status) query.push(`status[]=${status}`)
    if (sort) query.push(`sort[]=${sort}`)
    if (search) query.push(`search=${search}`)
    if (projectManager) query.push(`projectManager=${projectManager}`)
    if (businessConsultant) query.push(`businessConsultant=${businessConsultant}`)
    if (tags.length) query.push(...tags)
    const apiAddress = search ? 'requests' : 'requests/withoutelastic'
    return instCred.get(`${apiAddress}?${query.join('&')}`)
  },
  getRequestById: function (requestId) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get('requests/' + requestId)
  },
  createRequest: function (request) {
    request.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('requests', request)
  },
  createCommentRequest (request, id) {
    request.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post(`requests/comment/${id}`, request)
  },
  editCommentRequest (request, id) {
    request.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put(`requests/comment/${id}`, request)
  },
  editRequest: function (request) {
    request.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put('requests/' + request.id, request)
  },
  deleteRequest: function (requestId) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.delete('requests/' + requestId)
  }
}



// WEBPACK FOOTER //
// ./src/api/Requests/api.js